import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconAttributeExtractionS: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M 0 7 C 0 3.134 3.134 0 7 0 C 8.3197 0 9.554 0.3652 10.6076 1 H 7 C 3.6863 1 1 3.6863 1 7 C 1 10.3137 3.6863 13 7 13 H 10.6076 C 9.554 13.6348 8.3197 14 7 14 C 3.134 14 0 10.866 0 7 Z " />
    <path d="M 13.9871 6.5714 C 13.9665 6.231 13.9216 5.8971 13.8541 5.5714 H 7 V 6.5714 H 13.9871 Z" />
    <path d="M 13.6183 4.7143 C 13.4987 4.3678 13.3526 4.0337 13.1825 3.7143 H 7 V 4.7143 H 13.6183 Z" />
    <path d="M 12.643 2.8571 C 12.3772 2.4958 12.0776 2.1609 11.7488 1.8571 H 7 V 2.8571 H 12.643 Z" />
    <path d="M 13.9871 7.4286 C 13.9665 7.769 13.9216 8.1029 13.8541 8.4286 H 7 V 7.4286 H 13.9871 Z" />
    <path d="M 7 9.2857 H 13.6183 C 13.4987 9.6322 13.3526 9.9663 13.1825 10.2857 H 7 V 9.2857 Z" />
    <path d="M 7 11.1429 H 12.643 C 12.3773 11.5042 12.0776 11.8391 11.7488 12.1429 H 7 V 11.1429 Z" />
  </svg>
)

export const IconAttributeExtraction = createIcon({
  name: 'IconAttributeExtraction',
  l: IconAttributeExtractionS,
  m: IconAttributeExtractionS,
  s: IconAttributeExtractionS,
  xs: IconAttributeExtractionS,
})
